import { render } from "./FormInfo.vue?vue&type=template&id=5e0e250b&scoped=true"
import script from "./FormInfo.vue?vue&type=script&lang=js"
export * from "./FormInfo.vue?vue&type=script&lang=js"

import "./FormInfo.vue?vue&type=style&index=0&id=5e0e250b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0e250b"]])

export default __exports__